import type { JourneyType } from '~types/queryParam';

import SearchConditions from './SearchConditions';
import AppealSection from './AppealSection';
import PassRecommendation from './PassRecommendation';
import dynamic from 'next/dynamic';
import { useDetermineMobile } from '@myrealtrip/device-detect';
import { WeblogPageCategory, WeblogScreenName } from '~constants/weblog';

const AdsBannerList = dynamic(() => import('remote/AdsBannerList'), {
  ssr: false,
  loading: () => null,
});

interface Props {
  selectedJourney: JourneyType;
  onChangeJourney: (journey: JourneyType) => void;
}

const TicketTabContent = ({ selectedJourney, onChangeJourney }: Props) => {
  const isMobile = useDetermineMobile();

  return (
    <>
      <SearchConditions selectedJourney={selectedJourney} onChangeJourney={onChangeJourney} />
      <AdsBannerList
        screenName={WeblogScreenName.EUROPE_TRAIN_TICKET_MAIN}
        pageCategory={WeblogPageCategory.EUROPE_TRAIN_TICKET_MAIN}
        sectionName="AD_IMAGE_BANNERS_1"
        padding={isMobile ? '0 20px' : undefined}
        margin={isMobile ? '24px 0 0' : '32px 0 0'}
        borderRadius={12}
      />
      <AppealSection />
      <PassRecommendation />
    </>
  );
};

export default TicketTabContent;
